function setWishlistTotal () {
  const wishlistCountEls = document.querySelectorAll(
    '[data-swym-wishlist-count]',
  )

  window._swat.wishlistCount((count) => {
    wishlistCountEls.forEach(wishlistCountEl => {
      if (count > 0) {
        wishlistCountEl.textContent = count
        wishlistCountEl.setAttribute('aria-hidden', 'false')
      } else {
        wishlistCountEl.setAttribute('aria-hidden', 'true')
      }
    })
  })
}

function setProductCardWishlistStateToAdded (products) {
  products.forEach(product => {
    document
      .querySelectorAll(
        `[data-wishlist-button][data-variant-id="${product.epi.toString()}"]`,
      )
      .forEach(wishlistButtonEl => {
        wishlistButtonEl.setAttribute('data-wishlist-status', 'added')
      })
  })
}

function onSwymLoadCallback (swat) {
  if (swat) {
    window._swat.fetch(products => {
      window.wishlistProducts = products
      setWishlistTotal(products)
      setProductCardWishlistStateToAdded(products)
    })
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = []
}

window.SwymCallbacks.push(onSwymLoadCallback)

window.BAO.eventBus.addEventListener(window.BAO.EVENTS.WISHLIST.UPDATED, () => {
  window._swat.fetch((products) => {
    window.wishlistProducts = products
    setWishlistTotal(products)
    setProductCardWishlistStateToAdded(products)
  })
})
